import { render } from "./PersonToPersonIcon.vue?vue&type=template&id=ddcf22ea"
import script from "./PersonToPersonIcon.vue?vue&type=script&lang=js"
export * from "./PersonToPersonIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__